export type PlaybackVersion = {
  id: string
  role?: "PRIMARY" | "COMPATIBILITY"
  codec?: "H264" | "HEVC" | string
  priority?: number
}

export const browserSupportsHevc = (): boolean => {
  if (typeof document === "undefined") return false
  const video = document.createElement("video")
  return [
    'video/mp4; codecs="hvc1"',
    'video/mp4; codecs="hev1"',
  ].some(type => video.canPlayType(type) !== "")
}

export const isVersionSupported = (version: PlaybackVersion): boolean => {
  if (!version?.codec || version.codec === "H264") return true
  if (version.codec === "HEVC") return browserSupportsHevc()
  return false
}

export const selectPreferredVersion = (versions: PlaybackVersion[]): PlaybackVersion | undefined => {
  const ordered = [...(versions || [])].sort((left, right) => Number(left.priority ?? 100) - Number(right.priority ?? 100))
  return ordered.find(version => version.role === "PRIMARY" && isVersionSupported(version)) ||
    ordered.find(version => version.codec === "H264") ||
    ordered.find(isVersionSupported) ||
    ordered[0]
}
